import { AppState } from 'Store'

const getAll = (state: AppState) => state.referenceBooks.regions.regions
const getNoDivisions = (state: AppState) => state.referenceBooks.regions.regionsNoDivisions
const getEntries = (state: AppState) => state.referenceBooks.regions.regions.entries
const getOne = (state: AppState) => state.referenceBooks.regions.region
const getTotal = (state: AppState) => state.referenceBooks.regions.regions.total_entries
const getCurrentPageRegion = (state: AppState) => state.referenceBooks.regions.regions.current_page
const getParams = (state: AppState) => state.referenceBooks.regions.requestParams
const selectFormState = (state: AppState) => state.referenceBooks.regions.formState

export const regionsSelector = {
	getAll,
	getParams,
	getNoDivisions,
	getEntries,
	getOne,
	getTotal,
	getCurrentPageRegion,
	selectFormState,
}
